import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class NumberInput extends Component {
  state = {
    rawValue: null,
    isInvalid: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const { rawValue } = this.state;
      if (rawValue !== null) {
        const currentParsed = Number.parseFloat(String(rawValue).replace(',', '.'));
        if (currentParsed !== this.props.value) {
          this.setState({ rawValue: null, isInvalid: false });
        }
      }
    }
  }

  onInputChanged = val => {
    const { onChange, min, max, noDecimals, step } = this.props;
    const normalizedVal = noDecimals ? val : val.replace(',', '.');
    const isTrailingSeparator = !noDecimals && /^-?\d+[.,]$/.test(val);
    let parsedValue = noDecimals ? Number.parseInt(val) : Number.parseFloat(normalizedVal);

    if (Number.isNaN(parsedValue)) {
      this.setState({ rawValue: val, isInvalid: true });
      onChange(null);
    } else if (isTrailingSeparator) {
      this.setState({ rawValue: val, isInvalid: false });
      onChange(parsedValue);
    } else if (
      typeof step === 'number' &&
      step > 0 &&
      Math.abs(parsedValue % step) >
        1e-9 /* floating-point tolerance: 4.5 % 0.5 can produce ~1e-16 instead of 0 */
    ) {
      this.setState({ rawValue: val, isInvalid: true });
      onChange(null);
    } else {
      if (min !== null && !Number.isNaN(min) && min > parsedValue) parsedValue = min;
      if (max !== null && !Number.isNaN(max) && max < parsedValue) parsedValue = max;
      this.setState({ rawValue: val, isInvalid: false });
      onChange(parsedValue);
    }
  };
  
  // Submit on blur
  handleBlur = () => {
    const { onBlur, value, onChange } = this.props;
    const { isInvalid } = this.state;
    if (isInvalid) {
      this.setState({ rawValue: null, isInvalid: false });
      onChange(value || 0);
    }
    onBlur();
  };

  render() {
    const { value, className, noDecimals, step, min, max, onBlur, ...rest } = this.props;
    const { rawValue, isInvalid } = this.state;
    const safePropValue = value == null ? '' : value;

    return (
      <input
        {...rest}
        type="text"
        inputMode={noDecimals ? 'numeric' : 'decimal'}
        value={rawValue !== null ? rawValue : safePropValue}
        onChange={e => this.onInputChanged(e.target.value)}
        onBlur={this.handleBlur}
        className={classnames(className, 'form-control', {
          markedError: isInvalid,
        })}
      />
    );
  }
}
NumberInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  noDecimals: PropTypes.bool,
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

NumberInput.defaultProps = {
  value: 0,
  onBlur: () => {},
  className: '',
  min: null,
  max: null,
  noDecimals: false,
};
export default NumberInput;
